import React from "react"
import parse from "html-react-parser"
import { Container, Row, Col } from "@ui/wrapper"
import Heading from "@ui/heading"
import Text from "@ui/text"
import { SectionWrap } from "./style"
import { introArea } from "../../../dataMantiz/pages/company/ourHistory/introArea"

const IntroArea = ({ headingStyle, descStyle }) => {
  return (
    <SectionWrap>
      <Container>
        <Row>
          <Col lg={12}>
            <Heading {...headingStyle}>{parse(introArea.title1)}</Heading>
            <Text {...descStyle}>{introArea.title2}</Text>
          </Col>
        </Row>
      </Container>
    </SectionWrap>
  )
}

IntroArea.defaultProps = {
  headingStyle: {
    as: "h4",
    mb: "20px",
    child: {
      color: "primary",
    },
  },
  descStyle: {
    maxwidth: "760px",
    m: "auto",
  },
}

export default IntroArea
